module.exports = __webpack_public_path__ + "img/white-pink-flowers.ee8c6242.jpg";